import React from "react";
import styles from "./Reporting.module.scss";
import { Grid } from "@mui/material";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import { base64FileDownload, fileDownload } from "../../utils/FileDownloadUtil";
import { logMsg } from "../../common/Logger";
import DownloadButton from "../../shared/buttons/DownloadButton";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import NscReportingClient from "../../shared/clients/NscReportingClient";

function Reporting(props) {
  function downloadAppActionsLogReport(report) {
    props.hideOrShow(true);
    NscReportingClient.downloadAppActionsLogReport(props.user)
      .then((res) => {
        const filename =
          props.t(report.downLoadName) +
          " - " +
          getTodayDateDDMMYYYY() +
          ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  }

  function downloadDealerActivationReport(report) {
    props.hideOrShow(true);
    NscReportingClient.downloadDealerActivationReportInCsv(props.user)
      .then((res) => {
        const filename = props.t(report.name) + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  }

  function downloadDealerReservationSummary(report) {
    props.hideOrShow(true);
    NscReportingClient.downloadDealerReservationReport(
      props.user,
      props.user.market
    )
      .then((res) => {
        const filename = props.t(report.downLoadName) + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename,
          "reservation-reports"
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  }

  function getTodayDateDDMMYYYY() {
    const today = new Date();
    return `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
  }

  const commonReport = [
    {
      name: "Reporting.report1Title",
      key: "report1",
      downloadLink: downloadDealerActivationReport,
    },
  ];

  function getReports() {
    return [
      ...commonReport,
      {
        name: "Reporting.nscAppActionsLogReportTitle",
        downLoadName: "Reporting.nscAppActionsLogReportTitle",
        key: "report2",
        downloadLink: downloadAppActionsLogReport,
      },
      {
        name: "Reporting.report2Title",
        downLoadName: "Reporting.downloadDealerReport",
        key: "report2",
        downloadLink: downloadDealerReservationSummary,
      },
    ];
  }

  const reports = getReports();

  return (
    <div id="reporting">
      <section className="pageWrapper">
        <div id="reportingHeader">
          <SubNav
            dashboard={false}
            title={props.t("Reporting.subnav1")}
            {...props}
          />
        </div>
        <div className="pagePaddingLeft pagePaddingTop">
          <InfoIconWithMessage message={props.t("Reporting.bodyCopy")} />
        </div>
        <div>
          <Grid container className={styles.dataContainer}>
            <Grid
              item
              className={`${styles.headerContainer} ${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
            >
              <div>{props.t("Reporting.columnTitle1")}</div>
            </Grid>
            {reports.map((report) => (
              <React.Fragment key={report.key}>
                <Grid
                  container
                  className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                >
                  <Grid item md={10}>
                    <div className={styles.colValues}>
                      {props.t(report.name)}
                    </div>
                  </Grid>
                  <Grid item md={2} className={`${styles.end}`}>
                    <DownloadButton
                      download={() => report.downloadLink(report)}
                      text={props.t("Reporting.download")}
                    />
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </div>
      </section>
    </div>
  );
}

export default withTranslation("emp")(Reporting);
